import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-information",
  "use": "icon-information-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-information\"><path d=\"M755.88 596.43V373.35c0-133.84-109.52-243.36-243.36-243.36S269.16 239.51 269.16 373.35v223.08l-101.4 141.96h689.52l-101.4-141.96zM512.52 860.07c44.82 0 81.12-36.3 81.12-81.12H431.4c0 44.82 36.3 81.12 81.12 81.12z\" p-id=\"32041\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol